module.exports = __webpack_public_path__ + "static/media/sms1.614f473a.png";